import React from "react";
import Modal from "../../../../elements/Modal";
import ManageCalender from "../ManageCalender";

const ManageCalenderModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={"Create New "}>
      <ManageCalender getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageCalenderModal;
